'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dPage$0024 from "./presto.-Freemium2-F-A-Add-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002469 from "./presto.-Presto-Router$$anon$69.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$68() {
  this.bm0 = null;
  this.blS = null;
  this.blT = false;
  this.bm1 = null;
  this.bm2 = false;
  this.bm5 = null;
  this.blY = null;
  this.blZ = false;
  this.blU = null;
  this.blV = false;
  this.blW = null;
  this.blX = false;
  this.bm3 = false;
  this.bm4 = false;
  this.bm0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bm5 = "Freemium2FAAddPage";
}
export { $c_Lpresto_PrestoRouter$$anon$68 as $c_Lpresto_PrestoRouter$$anon$68 };
$p = $c_Lpresto_PrestoRouter$$anon$68.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$68;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$68() {
}
export { $h_Lpresto_PrestoRouter$$anon$68 as $h_Lpresto_PrestoRouter$$anon$68 };
$h_Lpresto_PrestoRouter$$anon$68.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bm0;
});
$p.L = (function() {
  if ((!this.blT)) {
    this.blS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.blT = true;
  }
  return this.blS;
});
$p.O = (function() {
  if ((!this.bm2)) {
    this.bm1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bm2 = true;
  }
  return this.bm1;
});
$p.E = (function() {
  return this.bm5;
});
$p.t = (function() {
  if ((!this.blZ)) {
    this.blY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.blZ = true;
  }
  return this.blY;
});
$p.M = (function() {
  if ((!this.blV)) {
    this.blU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.blV = true;
  }
  return this.blU;
});
$p.Q = (function() {
  if ((!this.blX)) {
    this.blW = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002469.$c_Lpresto_PrestoRouter$$anon$69();
    this.blX = true;
  }
  return this.blW;
});
$p.w = (function() {
  if ((!this.bm4)) {
    this.bm3 = false;
    this.bm4 = true;
  }
  return this.bm3;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee487) => ((p) => \u03b4scrutinee487))($j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dPage$0024.$m_Lpresto_Freemium2FAAddPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$68 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$68, "presto.PrestoRouter$$anon$68", ({
  OA: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$68 as $d_Lpresto_PrestoRouter$$anon$68 };
//# sourceMappingURL=presto.-Presto-Router$$anon$68.js.map
